"use client";

import React from "react";
import Link from "next/link";
import styles from "./BookingIncentiveSlide.module.scss";
import { AppButton } from "@/src/components/AppButton/AppButton";
import { Container } from "@mantine/core";

type LightBookingSlideSlice = {
    type: "booking-incentive-slide";
    title: string;
    description?: string;
    image?: string;
    cta?: {
        label: string;
        link: string;
    };
};

export function BookingIncentiveSlide({ slice }: { slice: LightBookingSlideSlice }) {
    const { title, description, image, cta } = slice;

    return (
        <section className={styles.root} aria-label="Réserver un créneau">
            <div className={styles.inner}>
                <div className={styles.content}>
                    <div className={styles.textBlock}>
                        <p className={styles.kicker}>Réservation</p>
                        <h2 className={styles.title}>{title}</h2>
                        {description ? <p className={styles.description}>{description}</p> : null}
                    </div>

                    {cta?.link ? (
                        <div className={styles.actions}>
                            <AppButton
                                component={Link}
                                href={cta.link}
                            >
                                {cta.label || "Réserver"}
                            </AppButton>
                        </div>
                    ) : null}
                </div>

                <div className={styles.visual} aria-hidden="true">
                    <div className={styles.visualGlow} />
                    {image ? (
                        <div className={styles.media}>
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img className={styles.img} src={image} alt="" loading="lazy" />
                        </div>
                    ) : (
                        <div className={styles.placeholder} />
                    )}
                </div>
            </div>
        </section>
    );
}